export default __webpack_public_path__ + "static/media/Doordash1.cbc2013c.svg";